import { useRouter } from 'next/router';
import * as React from 'react';
import { useUser } from 'src/queries';
import { useAnalytics } from './analytics-context';
import { redactUrlBeforeSend } from './redact-url-before-send';

export const usePageView = () => {
  const analytics = useAnalytics();
  const { asPath } = useRouter();
  const { data } = useUser();

  React.useEffect(() => {
    const { origin, pathname } = new URL(window.location.href);

    const redactedUrl = redactUrlBeforeSend(`${origin}${pathname}`);
    const redactedPathname = new URL(redactedUrl).pathname;

    void analytics.track('Page Viewed', {
      name: redactedPathname,
      path: redactedPathname,
      referrer: document.referrer,
      title: document.title,
      url: redactedUrl,
    });

    void analytics.page();
  }, [asPath, analytics]);

  React.useEffect(() => {
    if (data) {
      void analytics.identify(data.id, {
        email: data.email,
      });
    }
  }, [analytics, data]);
};
